<script lang="ts">
  import type { Resource, Service } from '@clinic/contracts';
  import { fa } from '../../../shared/i18n/fa';
  import { CheckboxLabel } from '../../../shared/ui';
  import { requirementLabel } from '../lib/resources';

  /**
   * Room and device of an appointment. Every room and device the clinic has defined can be chosen
   * for any service (employer request 2026-10-20; before, only a service that needed one showed the
   * choice, pilot feedback #10). What the service needs (e.g. laser) is picked first and the
   * server still refuses a booking without it; the rest is optional.
   */
  let {
    service,
    resources,
    value,
    onChange,
  }: {
    service: Service | undefined;
    resources: readonly Resource[];
    value: readonly string[];
    onChange: (ids: string[]) => void;
  } = $props();

  const required = $derived(service?.resourceRequirements ?? []);
  // Rooms before devices, each in the clinic's order.
  const ordered = $derived([...resources.filter((r) => r.kind === 'room'), ...resources.filter((r) => r.kind === 'device')]);
</script>

{#if resources.length > 0 || required.length > 0}
  <fieldset class="min-w-0">
    <legend class="mb-1 text-sm font-medium text-text-2">
      {fa.calendar.resources}{#if required.length === 0}{` (${fa.app.optional})`}{/if}
    </legend>
    {#if required.length > 0}
      <p class="mb-1 text-xs text-text-3">{fa.calendar.needs}: {required.map(requirementLabel).join('، ')}</p>
    {/if}
    {#if resources.length === 0}
      <p class="text-sm text-text-3">{fa.calendar.noResources}</p>
    {:else}
      <div class="flex flex-col">
        {#each ordered as r (r.id)}
          <CheckboxLabel
            label={`${r.name} · ${fa.settings.resources.kinds[r.kind]}`}
            checked={value.includes(r.id)}
            onChange={(on) => onChange(on ? [...value, r.id] : value.filter((x) => x !== r.id))}
          />
        {/each}
      </div>
    {/if}
  </fieldset>
{/if}
